module.exports = __webpack_public_path__ + "images/Carolina_Riascos.png?v=38bcf72bbb4c16ceed164e99b2ddf6d4";